"use client"

import { Button } from "@/components/ui/button"

interface HeroSectionProps {
  title: string
  subtitle: string
  shareButton: string
  onShare: () => void
}

export function HeroSection({ title, subtitle, shareButton, onShare }: HeroSectionProps) {
  return (
    <section className="py-12 md:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <div className="space-y-6">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">{title}</h1>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-3xl mx-auto">{subtitle}</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" onClick={onShare} className="w-full sm:w-auto">
              {shareButton}
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
